import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type CreateMessageModalCardThumbnailsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type CreateMessageModalCardThumbnailsQuery = {
  __typename?: 'Query';
  invitation: {
    __typename?: 'StationeryTemplateContainer';
    pagedResults: {
      __typename?: 'StationeryTemplateConnection';
      edges: Array<{ __typename?: 'StationeryTemplateEdge'; node: { __typename?: 'StationeryTemplate'; id: string; thumbnailUrl?: string | null } }>;
    };
  };
};

export const CreateMessageModalCardThumbnailsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CreateMessageModalCardThumbnails' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'invitation' },
            name: { kind: 'Name', value: 'stationeryTemplatesContainer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'categories' }, value: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'invitation' }] } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'approved' }, value: { kind: 'BooleanValue', value: true } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'enabled' }, value: { kind: 'BooleanValue', value: true } },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagedResults' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'first' }, value: { kind: 'IntValue', value: '12' } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCreateMessageModalCardThumbnailsQuery__
 *
 * To run a query within a React component, call `useCreateMessageModalCardThumbnailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageModalCardThumbnailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateMessageModalCardThumbnailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateMessageModalCardThumbnailsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<CreateMessageModalCardThumbnailsQuery, CreateMessageModalCardThumbnailsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<CreateMessageModalCardThumbnailsQuery, CreateMessageModalCardThumbnailsQueryVariables>(CreateMessageModalCardThumbnailsDocument, baseOptions);
}
export function useCreateMessageModalCardThumbnailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateMessageModalCardThumbnailsQuery, CreateMessageModalCardThumbnailsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<CreateMessageModalCardThumbnailsQuery, CreateMessageModalCardThumbnailsQueryVariables>(
    CreateMessageModalCardThumbnailsDocument,
    baseOptions,
  );
}
export type CreateMessageModalCardThumbnailsQueryHookResult = ReturnType<typeof useCreateMessageModalCardThumbnailsQuery>;
export type CreateMessageModalCardThumbnailsLazyQueryHookResult = ReturnType<typeof useCreateMessageModalCardThumbnailsLazyQuery>;
export type CreateMessageModalCardThumbnailsQueryResult = Apollo.QueryResult<CreateMessageModalCardThumbnailsQuery, CreateMessageModalCardThumbnailsQueryVariables>;
